module.exports = __webpack_public_path__ + "static/media/naka-itabashi-3.7378275e.jpg";